var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEyeFilled = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 22,
  height: 22,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#3A414C",
  d: "M8.508 11a2.406 2.406 0 1 0 4.812 0 2.406 2.406 0 0 0-4.812 0m11.735-.554c-2.037-4.29-5.116-6.45-9.243-6.45-4.13 0-7.206 2.16-9.243 6.452a1.3 1.3 0 0 0 0 1.106c2.037 4.29 5.116 6.45 9.243 6.45 4.13 0 7.206-2.16 9.243-6.452a1.3 1.3 0 0 0 0-1.106m-9.329 4.335a3.781 3.781 0 1 1 0-7.562 3.781 3.781 0 0 1 0 7.562"
})));
export { SvgEyeFilled as ReactComponent };
export default __webpack_public_path__ + "static/media/eyeFilled.a15ea72b.svg";